import * as RSwitch from '@radix-ui/react-switch';

export interface SwitchProps {
  label: string;
  checked: boolean;
  onCheckedChange(checked: boolean): void;
  disabled?: boolean;
  describedBy?: string;
}

export function Switch({ label, checked, onCheckedChange, disabled, describedBy }: SwitchProps) {
  return (
    <RSwitch.Root
      aria-label={label}
      aria-describedby={describedBy}
      checked={checked}
      disabled={disabled}
      onCheckedChange={onCheckedChange}
      className="group inline-flex h-11 w-16 shrink-0 items-center justify-center rounded-full disabled:cursor-not-allowed disabled:opacity-50"
    >
      <span
        aria-hidden
        className="flex h-7 w-12 items-center rounded-full bg-secondary px-0.5 group-data-[state=checked]:bg-accent"
      >
        <RSwitch.Thumb className="block h-6 w-6 rounded-full bg-fg data-[state=checked]:translate-x-5 data-[state=checked]:bg-on-accent motion-safe:transition-transform motion-safe:duration-150" />
      </span>
    </RSwitch.Root>
  );
}
